<template>
  <div class="d-flex flex-column gap-3 align-items-center w-100 px-3 pb-3">
    <div style="height: 150px; background-color: #056331; overflow: hidden;" class="d-flex align-items-center justify-content-center position-relative z-index-0 rounded-4 w-100 m-0 mt-lg-3">
      <!-- Imagen con filtro verde -->
      <img src="../assets/galeria.webp" alt="Galeria" class="img-fluid w-100 h-100 z-index-0" style="object-fit: cover;">

      <!-- Filtro verde -->
      <div style="position: absolute; top: 0; left: 0; right: 0; bottom: 0; background-color: rgba(89, 89, 89, 0.5);"></div>

      <!-- Texto encima de la imagen -->
      <div class="text-center position-absolute w-100 z-index-0">
        <p class="text-white fs-1 mb-0 fw-bold">{{ $t('galeriaDeFotos') }}</p>
      </div>
    </div>
    <div class="mx-5 container d-flex flex-column gap-4">
      <div class="d-flex flex-column gap-3">
        <div v-if="GaleriaPadre" class="d-flex flex-row align-items-center justify-content-start gap-2 m-0 w-100">
          <router-link v-if="GaleriaPadre.IdContenidoPadre" :to="'/galeria?idContenido=' + GaleriaPadre.IdContenidoPadre" class="btn d-flex align-items-center justify-content-center p-0 pt-1 tooltip-container" style="cursor: pointer;">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 12H18M6 12L11 7M6 12L11 17" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="tooltip-text">{{ $t('volver') }}</span>
          </router-link>
          <router-link v-if="!GaleriaPadre.IdContenidoPadre" to='/galeria' class="btn d-flex align-items-center justify-content-center p-0 pt-1 tooltip-container" style="cursor: pointer;">
            <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6 12H18M6 12L11 7M6 12L11 17" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span class="tooltip-text">{{ $t('volver') }}</span>
          </router-link>
          <h2 class="m-0 text-wrap" for="nombreContenido">{{ GaleriaPadre.Titulo }}</h2>
          <svg v-if="GaleriaPadre.EsPublicoATodos" width="30" height="30" viewBox="0 0 24 24" class="stroke-principal" style="margin-top: 1px;" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3 8.2C3 7.07989 3 6.51984 3.21799 6.09202C3.40973 5.71569 3.71569 5.40973 4.09202 5.21799C4.51984 5 5.0799 5 6.2 5H9.67452C10.1637 5 10.4083 5 10.6385 5.05526C10.8425 5.10425 11.0376 5.18506 11.2166 5.29472C11.4184 5.4184 11.5914 5.59135 11.9373 5.93726L12.0627 6.06274C12.4086 6.40865 12.5816 6.5816 12.7834 6.70528C12.9624 6.81494 13.1575 6.89575 13.3615 6.94474C13.5917 7 13.8363 7 14.3255 7H17.8C18.9201 7 19.4802 7 19.908 7.21799C20.2843 7.40973 20.5903 7.71569 20.782 8.09202C21 8.51984 21 9.0799 21 10.2V15.8C21 16.9201 21 17.4802 20.782 17.908C20.5903 18.2843 20.2843 18.5903 19.908 18.782C19.4802 19 18.9201 19 17.8 19H6.2C5.07989 19 4.51984 19 4.09202 18.782C3.71569 18.5903 3.40973 18.2843 3.21799 17.908C3 17.4802 3 16.9201 3 15.8V8.2Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <svg v-else width="30" height="30" viewBox="0 0 24 24" class="stroke-principal" style="margin-top: 1px;" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M14 13V12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12V13M10.5 16H13.5C13.9659 16 14.1989 16 14.3827 15.9239C14.6277 15.8224 14.8224 15.6277 14.9239 15.3827C15 15.1989 15 14.9659 15 14.5C15 14.0341 15 13.8011 14.9239 13.6173C14.8224 13.3723 14.6277 13.1776 14.3827 13.0761C14.1989 13 13.9659 13 13.5 13H10.5C10.0341 13 9.80109 13 9.61732 13.0761C9.37229 13.1776 9.17761 13.3723 9.07612 13.6173C9 13.8011 9 14.0341 9 14.5C9 14.9659 9 15.1989 9.07612 15.3827C9.17761 15.6277 9.37229 15.8224 9.61732 15.9239C9.80109 16 10.0341 16 10.5 16ZM12.0627 6.06274L11.9373 5.93726C11.5914 5.59135 11.4184 5.4184 11.2166 5.29472C11.0376 5.18506 10.8425 5.10425 10.6385 5.05526C10.4083 5 10.1637 5 9.67452 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V15.8C3 16.9201 3 17.4802 3.21799 17.908C3.40973 18.2843 3.71569 18.5903 4.09202 18.782C4.51984 19 5.07989 19 6.2 19H17.8C18.9201 19 19.4802 19 19.908 18.782C20.2843 18.5903 20.5903 18.2843 20.782 17.908C21 17.4802 21 16.9201 21 15.8V10.2C21 9.0799 21 8.51984 20.782 8.09202C20.5903 7.71569 20.2843 7.40973 19.908 7.21799C19.4802 7 18.9201 7 17.8 7H14.3255C13.8363 7 13.5917 7 13.3615 6.94474C13.1575 6.89575 12.9624 6.81494 12.7834 6.70528C12.5816 6.5816 12.4086 6.40865 12.0627 6.06274Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          <button v-if="GaleriaPadre.PermisoOtorgado == 'Editor'" class="btn btn-sm fondo-terciario rounded-3 p-2 sombra-sm" type="button" aria-expanded="false" @click="showModalAcceso = true; newGaleria = GaleriaPadre">
            <svg width="23" height="23" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" class="stroke-principal icon line-color" style="transform: scale(0.9);" data-name="Line Color">
              <g class="layer">
                <path d="m18.22,17.99l4,0m-2,-2l0,4" fill="#000" id="secondary" stroke=" rgb(44, 169, 188)" stroke-linecap=" round" stroke-linejoin=" round" stroke-width="2"/>
                <path d="m16.15,14.09a4.71,4.71 0 0 0 -1,-0.1l-6,0a5,5 0 0 0 -5,5l0,1s2,2 8,2a22,22 0 0 0 3,-0.19c0.35,0 0.69,-0.1 1,-0.17" fill=" none" id="primary"  stroke-linecap=" round" stroke-linejoin=" round" stroke-width="2"/>
                <path d="m7.08,10.67a5,5 0 0 0 -5,5l0,1" fill=" none" id="svg_1"  stroke-linecap=" round" stroke-linejoin=" round" stroke-width="2"/>
                <path d="m12.36,13.47c-2.71,0 -4.91,-2.2 -4.91,-4.92c0,-2.71 2.2,-4.91 4.91,-4.91c2.72,0 4.92,2.2 4.92,4.91c0,2.72 -2.2,4.92 -4.92,4.92z" fill="none" id="svg_9" opacity="undefined"  stroke-width="2" transform="matrix(1 0 0 1 0 0)"/>
                <line fill="none" id="svg_11"  stroke-linecap=" round" stroke-linejoin=" round" stroke-width="2" x1="2.1" x2="4.01" y1="17.06" y2="17.18"/>
                <path d="m6.46,9.28c-1.26,0.03 -2.88,-1.57 -2.88,-3.57c0,-1.99 1.62,-3.61 3.61,-3.61c2,0 3.47,1.8 3.07,1.98c-0.39,0.18 -1.2,0.63 -1.72,1.23c-0.52,0.6 -0.72,1.06 -1,2.09c-0.27,1.02 0.17,1.86 -1.09,1.88z" fill="none" id="svg_3" opacity="undefined"  stroke-width="2"/>
              </g>
            </svg>
          </button>
          <button v-if="GaleriaPadre.PermisoOtorgado == 'Editor'" class="btn btn-sm fondo-terciario rounded-3 p-2 sombra-sm" type="button" aria-expanded="false" @click.stop="openModalEdit(GaleriaPadre)">
            <svg width="22" height="22" viewBox="0 2 24 23" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
              <path d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M21 21H12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
          <button class="btn btn-sm fondo-terciario rounded-3 p-2 sombra-sm align-items-center justify-content-center" @click.stop="toggleShareMenu(GaleriaPadre.IdContenido)">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
              <path d="M9 12C9 13.3807 7.88071 14.5 6.5 14.5C5.11929 14.5 4 13.3807 4 12C4 10.6193 5.11929 9.5 6.5 9.5C7.88071 9.5 9 10.6193 9 12Z" stroke-width="1.5"/>
              <path d="M14 6.5L9 10" stroke-width="1.5" stroke-linecap="round"/>
              <path d="M14 17.5L9 14" stroke-width="1.5" stroke-linecap="round"/>
              <path d="M19 18.5C19 19.8807 17.8807 21 16.5 21C15.1193 21 14 19.8807 14 18.5C14 17.1193 15.1193 16 16.5 16C17.8807 16 19 17.1193 19 18.5Z" stroke-width="1.5"/>
              <path d="M19 5.5C19 6.88071 17.8807 8 16.5 8C15.1193 8 14 6.88071 14 5.5C14 4.11929 15.1193 3 16.5 3C17.8807 3 19 4.11929 19 5.5Z" stroke-width="1.5"/>
            </svg>
          </button>
        </div>
        <p v-if="GaleriaPadre && GaleriaPadre.Descripcion" class="m-0 w-100 texto-secundario">{{ GaleriaPadre.Descripcion }}</p>
        <div v-if="GaleriaPadre && GaleriaPadre.CodigoEmbebido" class="w-100 m-0">
          <span v-html="GaleriaPadre.CodigoEmbebido"></span>
        </div>
        <div class="d-flex align-items-center position-relative w-100 gap-2 m-0">
          <div class="d-flex align-items-center position-relative w-100 gap-2">
            <!-- Ícono SVG de lupa -->
            <svg width="20" height="20" viewBox="0 0 20 20" aria-hidden="true" class="position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary" style="pointer-events: none">
              <path d="M14.386 14.386l4.0877 4.0877-4.0877-4.0877c-2.9418 2.9419-7.7115 2.9419-10.6533 0-2.9419-2.9418-2.9419-7.7115 0-10.6533 2.9418-2.9419 7.7115-2.9419 10.6533 0 2.9419 2.9418 2.9419 7.7115 0 10.6533z" stroke="currentColor"  fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"></path>
            </svg>
            <input type="text" class="form-control m-0 rounded-3 borde-terciario fondo-terciario sombra" :placeholder="$t('buscarGalerias') + '...'" v-model="searchTerm"
              style="padding-left: 40px;" @keyup.enter="fetchGalerias(1)" @input="filterGalerias"/>
            <button v-if="searchTerm" type="button" class="position-absolute top-50 end-0 translate-middle-y border-0 bg-transparent" @click="searchTerm = ''; fetchGalerias(1)">
              <i class="bi bi-x text-secondary" style="font-size: 30px;"></i> <!-- Icono de "x" -->
            </button>
          </div>
          <div v-if="CrearGalerias" class=" dropup-center sombra p-0 rounded-3 m-auto">
            <button class="btn bg-goethe-accent fondo-terciario rounded-3 p-1" type="button" data-bs-toggle="dropdown" aria-expanded="false">
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 12H18M12 6V18" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </button>
            <ul class="dropdown-menu fondo-terciario borde-secundario">
              <li style="cursor: pointer;">
                <a class="dropdown-item texto-secundario home-list" @click="openModalNew(true)">
                  <svg width="17" height="17" viewBox="2 2 20 20" class="stroke-principal" style="margin-bottom: 1px;" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 8.2C3 7.07989 3 6.51984 3.21799 6.09202C3.40973 5.71569 3.71569 5.40973 4.09202 5.21799C4.51984 5 5.0799 5 6.2 5H9.67452C10.1637 5 10.4083 5 10.6385 5.05526C10.8425 5.10425 11.0376 5.18506 11.2166 5.29472C11.4184 5.4184 11.5914 5.59135 11.9373 5.93726L12.0627 6.06274C12.4086 6.40865 12.5816 6.5816 12.7834 6.70528C12.9624 6.81494 13.1575 6.89575 13.3615 6.94474C13.5917 7 13.8363 7 14.3255 7H17.8C18.9201 7 19.4802 7 19.908 7.21799C20.2843 7.40973 20.5903 7.71569 20.782 8.09202C21 8.51984 21 9.0799 21 10.2V15.8C21 16.9201 21 17.4802 20.782 17.908C20.5903 18.2843 20.2843 18.5903 19.908 18.782C19.4802 19 18.9201 19 17.8 19H6.2C5.07989 19 4.51984 19 4.09202 18.782C3.71569 18.5903 3.40973 18.2843 3.21799 17.908C3 17.4802 3 16.9201 3 15.8V8.2Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  {{ $t('carpeta') }}
                </a>
              </li>
              <li style="cursor: pointer;">
                <a class="dropdown-item texto-secundario home-list d-flex align-items-center gap-1 fs-6" @click="openModalNew(false)">
                  <svg class="stroke-principal" width="18" height="18" viewBox="0 1 24 23" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M2 12C2 7.28595 2 4.92893 3.46447 3.46447C4.92893 2 7.28595 2 12 2C16.714 2 19.0711 2 20.5355 3.46447C22 4.92893 22 7.28595 22 12C22 16.714 22 19.0711 20.5355 20.5355C19.0711 22 16.714 22 12 22C7.28595 22 4.92893 22 3.46447 20.5355C2 19.0711 2 16.714 2 12Z" stroke-width="2"/>
                      <circle cx="16" cy="8" r="2" stroke-width="2"/>
                    <path d="M2 12.5001L3.75159 10.9675C4.66286 10.1702 6.03628 10.2159 6.89249 11.0721L11.1822 15.3618C11.8694 16.0491 12.9512 16.1428 13.7464 15.5839L14.0446 15.3744C15.1888 14.5702 16.7369 14.6634 17.7765 15.599L21 18.5001" stroke-width="2" stroke-linecap="round"/>
                  </svg>
                  {{ $t('galeria') }}
                </a>
              </li>
            </ul>
          </div>
        </div>
        <!-- Mostrar las galerias Padres -->
        <div class="row row-cols-1 row-cols-md-2 row-cols-lg-3 row-cols-xl-4 g-4">
          <!-- No es carpeta -->
          <div class="col card-hover-scale" v-for="galeria in galerias" :key="galeria.IdContenido">
            <!-- Es Galeria -->
            <div v-if="galeria.EsCarpeta != true" @click="redirectUrl(galeria.RedirectionUrl)" class="card rounded-4 border-0 shadow d-flex flex-column fondo-terciario sombra-sm texto-principal" style="height: 100%; cursor: pointer">
              <img v-if="galeria.ImagenUrl && !galeria.imagenError" :src="galeria.ImagenUrl" alt="Galerias" class="card-img-top rounded-top-4 object-fit-cover" style="height: 200px;" @error="galeria.imagenError = true">
              <div v-if="(!galeria.ImagenUrl || galeria.imagenError)" class="d-flex justify-content-center align-items-center fondo-secundario card-img-top rounded-top-4 object-fit-cover" style="height: 200px;">
                <i class="bi bi-image fs-1 texto-secundario"></i>
              </div>
              <div class="position-absolute top-0 end-0 d-flex p-2 gap-2" @click.stop style="z-index: 900;">
                <button v-if="galeria.PermisoOtorgado == 'Editor'" class="btn btn-sm fondo-terciario rounded-3 p-2 sombra-sm" type="button" aria-expanded="false" @click.stop="showModalAcceso = true; newGaleria = galeria">
                  <svg width="23" height="23" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" class="stroke-principal icon line-color" style="transform: scale(0.9);" data-name="Line Color">
                    <g class="layer">
                      <path d="m18.22,17.99l4,0m-2,-2l0,4" fill="#000" id="secondary" stroke=" rgb(44, 169, 188)" stroke-linecap=" round" stroke-linejoin=" round" stroke-width="2"/>
                      <path d="m16.15,14.09a4.71,4.71 0 0 0 -1,-0.1l-6,0a5,5 0 0 0 -5,5l0,1s2,2 8,2a22,22 0 0 0 3,-0.19c0.35,0 0.69,-0.1 1,-0.17" fill=" none" id="primary"  stroke-linecap=" round" stroke-linejoin=" round" stroke-width="2"/>
                      <path d="m7.08,10.67a5,5 0 0 0 -5,5l0,1" fill=" none" id="svg_1"  stroke-linecap=" round" stroke-linejoin=" round" stroke-width="2"/>
                      <path d="m12.36,13.47c-2.71,0 -4.91,-2.2 -4.91,-4.92c0,-2.71 2.2,-4.91 4.91,-4.91c2.72,0 4.92,2.2 4.92,4.91c0,2.72 -2.2,4.92 -4.92,4.92z" fill="none" id="svg_9" opacity="undefined"  stroke-width="2" transform="matrix(1 0 0 1 0 0)"/>
                      <line fill="none" id="svg_11"  stroke-linecap=" round" stroke-linejoin=" round" stroke-width="2" x1="2.1" x2="4.01" y1="17.06" y2="17.18"/>
                      <path d="m6.46,9.28c-1.26,0.03 -2.88,-1.57 -2.88,-3.57c0,-1.99 1.62,-3.61 3.61,-3.61c2,0 3.47,1.8 3.07,1.98c-0.39,0.18 -1.2,0.63 -1.72,1.23c-0.52,0.6 -0.72,1.06 -1,2.09c-0.27,1.02 0.17,1.86 -1.09,1.88z" fill="none" id="svg_3" opacity="undefined"  stroke-width="2"/>
                    </g>
                  </svg>
                </button>
                <button v-if="galeria.PermisoOtorgado == 'Editor'" class="btn btn-sm fondo-terciario rounded-3 p-2 sombra-sm" type="button" aria-expanded="false" @click.stop="openModalEdit(galeria)">
                  <svg width="20" height="20" viewBox="0 2 24 23" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
                    <path d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M21 21H12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                <button class="btn btn-sm fondo-terciario rounded-3 p-2 sombra-sm align-items-center justify-content-center" @click.stop="showShareMenu = true; urlCompartir = galeria.RedirectionUrl">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
                    <path d="M9 12C9 13.3807 7.88071 14.5 6.5 14.5C5.11929 14.5 4 13.3807 4 12C4 10.6193 5.11929 9.5 6.5 9.5C7.88071 9.5 9 10.6193 9 12Z" stroke-width="1.5"/>
                    <path d="M14 6.5L9 10" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M14 17.5L9 14" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M19 18.5C19 19.8807 17.8807 21 16.5 21C15.1193 21 14 19.8807 14 18.5C14 17.1193 15.1193 16 16.5 16C17.8807 16 19 17.1193 19 18.5Z" stroke-width="1.5"/>
                    <path d="M19 5.5C19 6.88071 17.8807 8 16.5 8C15.1193 8 14 6.88071 14 5.5C14 4.11929 15.1193 3 16.5 3C17.8807 3 19 4.11929 19 5.5Z" stroke-width="1.5"/>
                  </svg>
                </button>
              </div>
              <div class="card-body text-start">
                <p v-if="galeria.ruta" class="card-text texto-secundario fs-7 m-0">{{ $t('ruta') + ": " + galeria.ruta }}/</p>
                <p class="d-flex align-items-center gap-2 card-text fw-semibold fs-6 m-0">
                  {{ galeria.Titulo }}
                  <svg v-if="!galeria.EsPublicoATodos" width="16" height="16" viewBox="0 0 24 24" style="margin-bottom: 2px;" fill="none" class="stroke-principal" xmlns="http://www.w3.org/2000/svg">
                    <path d="M12 14.5V16.5M7 10.0288C7.47142 10 8.05259 10 8.8 10H15.2C15.9474 10 16.5286 10 17 10.0288M7 10.0288C6.41168 10.0647 5.99429 10.1455 5.63803 10.327C5.07354 10.6146 4.6146 11.0735 4.32698 11.638C4 12.2798 4 13.1198 4 14.8V16.2C4 17.8802 4 18.7202 4.32698 19.362C4.6146 19.9265 5.07354 20.3854 5.63803 20.673C6.27976 21 7.11984 21 8.8 21H15.2C16.8802 21 17.7202 21 18.362 20.673C18.9265 20.3854 19.3854 19.9265 19.673 19.362C20 18.7202 20 17.8802 20 16.2V14.8C20 13.1198 20 12.2798 19.673 11.638C19.3854 11.0735 18.9265 10.6146 18.362 10.327C18.0057 10.1455 17.5883 10.0647 17 10.0288M7 10.0288V8C7 5.23858 9.23858 3 12 3C14.7614 3 17 5.23858 17 8V10.0288" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" class="stroke-principal" style="margin-bottom: 2px;" xmlns="http://www.w3.org/2000/svg">
                    <path id="Vector" d="M10.0002 5H8.2002C7.08009 5 6.51962 5 6.0918 5.21799C5.71547 5.40973 5.40973 5.71547 5.21799 6.0918C5 6.51962 5 7.08009 5 8.2002V15.8002C5 16.9203 5 17.4801 5.21799 17.9079C5.40973 18.2842 5.71547 18.5905 6.0918 18.7822C6.5192 19 7.07899 19 8.19691 19H15.8031C16.921 19 17.48 19 17.9074 18.7822C18.2837 18.5905 18.5905 18.2839 18.7822 17.9076C19 17.4802 19 16.921 19 15.8031V14M20 9V4M20 4H15M20 4L13 11" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </p>
                <p class="card-text texto-secundario fs-7" :class="{'text-truncate-1': galeria.ruta, 'text-truncate-2': !galeria.ruta}">{{ galeria.Descripcion }}</p>
              </div>
              <div v-if="!galeria.Habilitado" class="black-overlay rounded-4" style="position: absolute; height: 100%; width: 100%; top: 0; left: 0;"></div>
            </div>
            <!-- Es Carpeta -->
            <div v-if="galeria.EsCarpeta == true" @click.stop="goToGaleria(galeria.IdContenido)" class="card rounded-4 border-0 shadow d-flex flex-column fondo-terciario sombra-sm texto-principal" style="height: 100%;">
              <img v-if="galeria.ImagenUrl && !galeria.imagenError" :src="galeria.ImagenUrl" alt="Galerias" class="card-img-top rounded-top-4 object-fit-cover" style="height: 200px;" @error="galeria.imagenError = true">
              <div v-if="(!galeria.ImagenUrl || galeria.imagenError)" class="d-flex justify-content-center align-items-center fondo-secundario card-img-top rounded-top-4 object-fit-cover" style="height: 200px;">
                <i class="bi bi-image fs-1 texto-secundario"></i>
              </div>
              <div class="dropup-center position-absolute top-0 end-0 d-flex p-2 gap-2" @click.stop style="z-index: 900">
                <button v-if="galeria.PermisoOtorgado == 'Editor'" class="btn btn-sm fondo-terciario rounded-3 p-2 sombra-sm" type="button" aria-expanded="false" @click.stop="showModalAcceso = true; newGaleria = galeria">
                  <svg width="23" height="23" xmlns="http://www.w3.org/2000/svg" xmlns:svg="http://www.w3.org/2000/svg" class="stroke-principal icon line-color" style="transform: scale(0.9);" data-name="Line Color">
                    <g class="layer">
                      <path d="m18.22,17.99l4,0m-2,-2l0,4" fill="#000" id="secondary" stroke=" rgb(44, 169, 188)" stroke-linecap=" round" stroke-linejoin=" round" stroke-width="2"/>
                      <path d="m16.15,14.09a4.71,4.71 0 0 0 -1,-0.1l-6,0a5,5 0 0 0 -5,5l0,1s2,2 8,2a22,22 0 0 0 3,-0.19c0.35,0 0.69,-0.1 1,-0.17" fill=" none" id="primary"  stroke-linecap=" round" stroke-linejoin=" round" stroke-width="2"/>
                      <path d="m7.08,10.67a5,5 0 0 0 -5,5l0,1" fill=" none" id="svg_1"  stroke-linecap=" round" stroke-linejoin=" round" stroke-width="2"/>
                      <path d="m12.36,13.47c-2.71,0 -4.91,-2.2 -4.91,-4.92c0,-2.71 2.2,-4.91 4.91,-4.91c2.72,0 4.92,2.2 4.92,4.91c0,2.72 -2.2,4.92 -4.92,4.92z" fill="none" id="svg_9" opacity="undefined"  stroke-width="2" transform="matrix(1 0 0 1 0 0)"/>
                      <line fill="none" id="svg_11"  stroke-linecap=" round" stroke-linejoin=" round" stroke-width="2" x1="2.1" x2="4.01" y1="17.06" y2="17.18"/>
                      <path d="m6.46,9.28c-1.26,0.03 -2.88,-1.57 -2.88,-3.57c0,-1.99 1.62,-3.61 3.61,-3.61c2,0 3.47,1.8 3.07,1.98c-0.39,0.18 -1.2,0.63 -1.72,1.23c-0.52,0.6 -0.72,1.06 -1,2.09c-0.27,1.02 0.17,1.86 -1.09,1.88z" fill="none" id="svg_3" opacity="undefined"  stroke-width="2"/>
                    </g>
                  </svg>
                </button>
                <button v-if="galeria.PermisoOtorgado == 'Editor'" class="btn btn-sm fondo-terciario rounded-3 p-2 sombra-sm" type="button" aria-expanded="false" @click.stop="openModalEdit(galeria)">
                  <svg width="20" height="20" viewBox="0 2 24 23" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
                    <path d="M20.1497 7.93997L8.27971 19.81C7.21971 20.88 4.04971 21.3699 3.27971 20.6599C2.50971 19.9499 3.06969 16.78 4.12969 15.71L15.9997 3.84C16.5478 3.31801 17.2783 3.03097 18.0351 3.04019C18.7919 3.04942 19.5151 3.35418 20.0503 3.88938C20.5855 4.42457 20.8903 5.14781 20.8995 5.90463C20.9088 6.66146 20.6217 7.39189 20.0997 7.93997H20.1497Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                    <path d="M21 21H12" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </button>
                <button class="btn btn-sm fondo-terciario rounded-3 p-2 sombra-sm align-items-center justify-content-center" @click.stop="toggleShareMenu(galeria.IdContenido)">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
                    <path d="M9 12C9 13.3807 7.88071 14.5 6.5 14.5C5.11929 14.5 4 13.3807 4 12C4 10.6193 5.11929 9.5 6.5 9.5C7.88071 9.5 9 10.6193 9 12Z" stroke-width="1.5"/>
                    <path d="M14 6.5L9 10" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M14 17.5L9 14" stroke-width="1.5" stroke-linecap="round"/>
                    <path d="M19 18.5C19 19.8807 17.8807 21 16.5 21C15.1193 21 14 19.8807 14 18.5C14 17.1193 15.1193 16 16.5 16C17.8807 16 19 17.1193 19 18.5Z" stroke-width="1.5"/>
                    <path d="M19 5.5C19 6.88071 17.8807 8 16.5 8C15.1193 8 14 6.88071 14 5.5C14 4.11929 15.1193 3 16.5 3C17.8807 3 19 4.11929 19 5.5Z" stroke-width="1.5"/>
                  </svg>
                </button>
              </div>
              <div class="card-body text-start">
                <p v-if="galeria.ruta" class="card-text texto-secundario fs-7 m-0">{{ $t('ruta') + ": " + galeria.ruta }}/</p>
                <div class="d-flex gap-1">
                  <p class="card-text fw-semibold fs-6 m-0">{{ galeria.Titulo }}</p>
                  <svg v-if="galeria.EsPublicoATodos" width="20" height="20" viewBox="0 0 24 24" class="stroke-principal" style="margin-top: 1px;" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M3 8.2C3 7.07989 3 6.51984 3.21799 6.09202C3.40973 5.71569 3.71569 5.40973 4.09202 5.21799C4.51984 5 5.0799 5 6.2 5H9.67452C10.1637 5 10.4083 5 10.6385 5.05526C10.8425 5.10425 11.0376 5.18506 11.2166 5.29472C11.4184 5.4184 11.5914 5.59135 11.9373 5.93726L12.0627 6.06274C12.4086 6.40865 12.5816 6.5816 12.7834 6.70528C12.9624 6.81494 13.1575 6.89575 13.3615 6.94474C13.5917 7 13.8363 7 14.3255 7H17.8C18.9201 7 19.4802 7 19.908 7.21799C20.2843 7.40973 20.5903 7.71569 20.782 8.09202C21 8.51984 21 9.0799 21 10.2V15.8C21 16.9201 21 17.4802 20.782 17.908C20.5903 18.2843 20.2843 18.5903 19.908 18.782C19.4802 19 18.9201 19 17.8 19H6.2C5.07989 19 4.51984 19 4.09202 18.782C3.71569 18.5903 3.40973 18.2843 3.21799 17.908C3 17.4802 3 16.9201 3 15.8V8.2Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                  <svg v-else width="20" height="20" viewBox="0 0 24 24" class="stroke-principal" style="margin-top: 1px;" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M14 13V12C14 10.8954 13.1046 10 12 10C10.8954 10 10 10.8954 10 12V13M10.5 16H13.5C13.9659 16 14.1989 16 14.3827 15.9239C14.6277 15.8224 14.8224 15.6277 14.9239 15.3827C15 15.1989 15 14.9659 15 14.5C15 14.0341 15 13.8011 14.9239 13.6173C14.8224 13.3723 14.6277 13.1776 14.3827 13.0761C14.1989 13 13.9659 13 13.5 13H10.5C10.0341 13 9.80109 13 9.61732 13.0761C9.37229 13.1776 9.17761 13.3723 9.07612 13.6173C9 13.8011 9 14.0341 9 14.5C9 14.9659 9 15.1989 9.07612 15.3827C9.17761 15.6277 9.37229 15.8224 9.61732 15.9239C9.80109 16 10.0341 16 10.5 16ZM12.0627 6.06274L11.9373 5.93726C11.5914 5.59135 11.4184 5.4184 11.2166 5.29472C11.0376 5.18506 10.8425 5.10425 10.6385 5.05526C10.4083 5 10.1637 5 9.67452 5H6.2C5.0799 5 4.51984 5 4.09202 5.21799C3.71569 5.40973 3.40973 5.71569 3.21799 6.09202C3 6.51984 3 7.07989 3 8.2V15.8C3 16.9201 3 17.4802 3.21799 17.908C3.40973 18.2843 3.71569 18.5903 4.09202 18.782C4.51984 19 5.07989 19 6.2 19H17.8C18.9201 19 19.4802 19 19.908 18.782C20.2843 18.5903 20.5903 18.2843 20.782 17.908C21 17.4802 21 16.9201 21 15.8V10.2C21 9.0799 21 8.51984 20.782 8.09202C20.5903 7.71569 20.2843 7.40973 19.908 7.21799C19.4802 7 18.9201 7 17.8 7H14.3255C13.8363 7 13.5917 7 13.3615 6.94474C13.1575 6.89575 12.9624 6.81494 12.7834 6.70528C12.5816 6.5816 12.4086 6.40865 12.0627 6.06274Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  </svg>
                </div>
                <p class="card-text texto-secundario fs-7" :class="{'text-truncate-1': galeria.ruta, 'text-truncate-2': !galeria.ruta}">{{ galeria.Descripcion }}</p>
              </div>
              <div v-if="!galeria.Habilitado" class="black-overlay rounded-4" style="position: absolute; height: 100%; width: 100%; top: 0; left: 0;"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loading" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
      <img src="../assets/LOADING.gif" style="width: 80px;" alt="Cargando..." />
    </div>

    <div ref="loader" class="w-100 text-center p-4">
      <div v-if="loading && currentPage < totalPages" class="spinner-border text-secondary" role="status">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>


    <!-- Modal para editar accesos del galeria -->
    <div v-if="showModalAcceso && newGaleria?.PermisoOtorgado == 'Editor'" class="overlay" @click="showModalAcceso = false; newGaleria = null"></div>
    <div v-if="showModalAcceso && newGaleria?.PermisoOtorgado == 'Editor'" class="share-menu d-flex flex-column gap-2 fondo-principal">
      <div class="close-icon d-flex align-items-center" @click="showModalAcceso = false; newGaleria = null">
        <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_429_11083)">
            <path d="M7 7.00006L17 17.0001M7 17.0001L17 7.00006" class="stroke-principal" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
          <defs>
            <clipPath id="clip0_429_11083">
              <rect width="24" height="24" class="fill-principal"/>
            </clipPath>
          </defs>
        </svg>
      </div>

      <p class="fw-bold text-start m-0">{{ $t('agregarPersonas') }}:</p>

      <form @submit.prevent="submit" class="d-flex flex-column gap-2">
        <div class="select-wrapper" style="width: 250px;">
          <select v-model="tipoAcceso" class="form-select sombra-sm texto-principal borde-terciario" required>
            <option value="persona">{{ $t('personaEspecifica') }}</option>
            <option value="grupo">{{ $t('grupo') }}</option>
          </select>
          <svg class="select-icon fill-principal" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
          </svg>
        </div>
        <div v-if="tipoAcceso == 'persona'" class="d-flex flex-row align-items-center gap-2">
          <div class="position-relative w-100 d-flex flex-row">
            <input type="text" v-model="searchQuery" :placeholder="$t('buscarPersona')+'...'" class="form-control w-100 sombra-sm" @input="filterPersonas" required/>
            <ul v-if="filteredPersonas.length > 0" class="list-group position-absolute sombra-sm" style="z-index: 1000; width: 100%; top: 100%;">
              <li v-for="evaluado in filteredPersonas"  :key="evaluado.IdPersona"  class="list-group-item list-group-item-action d-flex flex-column" @click="selectPersona(evaluado)" style="cursor: pointer;">
                <span class="fs-7">{{ evaluado?.Apellido + ' ' + evaluado?.Nombre }}</span>
                <span class="fs-7" v-if="evaluado.Email && evaluado.Email.length > 0">{{ evaluado.Email[0]?.email }}</span>
              </li>
            </ul>

            <div v-if="loadingSubmitAcceso" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
              <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
            </div>
          </div>
          <div class="select-wrapper">
            <select style="width: 150px;" v-model="tipoPermiso" class="form-select sombra-sm texto-principal borde-terciario" required>
              <option value="Lector">{{ $t('lector') }}</option>
              <option value="Editor">{{ $t('editor') }}</option>
            </select>
            <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
            </svg>
          </div>
          <button type="submit" class="btn btn-success sombra-sm">
            {{ $t('agregar') }}
          </button>
        </div>
        <div v-if="tipoAcceso == 'grupo'" class="d-flex flex-row align-items-center gap-2">
          <div class="position-relative w-100 d-flex flex-row">
            <input type="text" v-model="searchQuery" :placeholder="$t('buscarLista')+'...'" class="form-control w-100 sombra-sm" @input="filterLista" required/>
            <ul v-if="filteredLista != null && filteredLista.length > 0" class="list-group position-absolute sombra-sm" style="z-index: 1000; width: 100%; top: 100%; max-height: 200px; overflow-y: auto;">
              <li v-for="lista in filteredLista" :key="lista.IdPersona" class="list-group-item list-group-item-action d-flex flex-column" @click="selectLista(lista)" style="cursor: pointer;">
                <span class="fs-7">{{ lista.Nombre }}</span>
              </li>
            </ul>

            <div v-if="loadingListas" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
              <img src="@/assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
            </div>
          </div>
          <div class="select-wrapper">
            <select style="width: 150px;" v-model="tipoPermiso" class="form-select sombra-sm texto-principal borde-terciario" required>
              <option v-if="newGaleria.EsPublicoATodos != true" value="Lector">{{ $t('lector') }}</option>
              <option value="Editor">{{ $t('editor') }}</option>
            </select>
            <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
              <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
            </svg>
          </div>
          <button type="submit" class="btn btn-success sombra-sm">
            {{ $t('agregar') }}
          </button>
        </div>
        
        <!-- <div class="form-check d-flex align-items-center gap-2 ps-1" style="cursor: pointer;">
          <input
            id="checkbox-todos"
            type="checkbox"
            class="checkbox-custom sombra-sm"
            v-model="conEnvio"
          />
          <label for="checkbox-todos" class="form-check-label">
            {{ $t('conEnvioDeEmail') }}
          </label>
        </div> -->
      </form>
      <svg xmlns="http://www.w3.org/2000/svg" class="d-none">
        <symbol id="exclamation-triangle-fill" viewBox="0 0 16 16">
            <path d="M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767L8.982 1.566zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5zm.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2z" />
        </symbol>
      </svg>
      <div class="alert alert-danger d-flex align-items-center mt-3 mb-0 p-1" v-if="errorMessage!=''" role="alert">
        <svg class="bi flex-shrink-0 mx-2" role="img" aria-label="Danger:" style="width:16px; height:16px"><use xlink:href="#exclamation-triangle-fill" /></svg>
        <p class="m-0">{{ errorMessage }}</p>
      </div>

      <div class="my-1">
        <p class="m-0 fs-8 text-start texto-principal"> - {{ $t('lector') }}: {{ $t('permisosLectorGaleria') }}</p>
        <p class="m-0 fs-8 text-start texto-principal"> - {{ $t('editor') }}: {{ $t('permisosEditorGaleria') }}</p>
      </div>

      <!-- Divider -->
      <div class="col-12 my-2" style="border-top: 1px solid #ddd; height: 1px"></div>

      <!-- Mostrar la lista de personas con acceso -->
      <p v-if="newGaleria.AccesosContenido?.some( af => af.IdLista != null)" class="m-0 fs-6 fw-bold text-start">{{ $t('gruposConAcceso') }}:</p>
      <div style="max-height: 250px; overflow-y: auto; overflow-x: hidden;" class="d-flex flex-column">
        <div v-for="acceso in newGaleria.AccesosContenido?.filter( af => af.IdLista != null)" :key="acceso.IdPersona" class="m-0 fs-7 py-1 text-start d-flex justify-content-between hover-row">
          <div class="d-flex flex-column align-items-start">
            <span>{{ acceso.IdListaNavigation.Nombre }}</span>
          </div>
          <div class="d-flex flex-row gap-1 align-items-center">
            <div class="select-wrapper">
              <select style="width: 135px;" v-model="acceso.TipoPermiso" class="form-select fs-7 sombra-sm texto-principal" @change="actualizarAcceso(acceso)">
                <option value="Lector">{{ $t('lector') }}</option>
                <option value="Editor">{{ $t('editor') }}</option>
              </select>
              <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
              </svg>
            </div>
            <!-- <button class="btn btn-danger btn-sm ms-2 fs-8" @click="removeAccess(acceso.idPersona)">Eliminar</button> -->
            <button v-if="newGaleria.PermisoOtorgado == 'Editor'" type="button" class="btn p-2 me-1 d-flex flex-row align-items-center justify-content-center tooltip-container border-0" @click="deleteAcceso(acceso)">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
                <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <!-- <span class="tooltip-text">{{ $t('eliminar') }}</span> -->
            </button>
          </div>
        </div>
      </div>
      <p class="m-0 fs-6 fw-bold text-start">{{ $t('personasConAcceso') }}:</p>
      <div style="max-height: 250px; overflow-y: auto; overflow-x: hidden;" class="d-flex flex-column">
        <div class="m-0 fs-7 py-1 text-start d-flex justify-content-between hover-row">
          <div class="d-flex flex-column align-items-start justify-content-center">
            <span>{{ newGaleria.Creador?.Apellido }} {{ newGaleria.Creador?.Nombre }}</span>
          </div>
          <div class="d-flex flex-row gap-1 align-items-center fondo-secundario rounded-2 p-1 px-2 sombra-sm" style="width: 135px; margin-right: 44px;">
            <span>{{ $t('creador') }}</span>
          </div>
        </div>
        <div v-for="acceso in newGaleria.AccesosContenido?.filter( af => af.IdPersona != null)" :key="acceso.IdPersona" class="m-0 fs-7 py-1 text-start d-flex justify-content-between hover-row">
          <div class="d-flex flex-column align-items-start">
            <span>{{ acceso.Persona?.Apellido }} {{ acceso.Persona?.Nombre }}</span>
            <span v-if="acceso.Persona.Email && acceso.Persona.Email.length > 0">
              {{ acceso.Persona.Email.find(e => e.TipoEmail == 'Profesional')?.email }}
            </span>
          </div>
          <div class="d-flex flex-row gap-1 align-items-center">
            <div class="select-wrapper">
              <select style="width: 135px;" v-model="acceso.TipoPermiso" class="form-select fs-7 sombra-sm texto-principal" @change="actualizarAcceso(acceso)">
                <option value="Lector">{{ $t('lector') }}</option>
                <option value="Editor">{{ $t('editor') }}</option>
              </select>
              <svg class="select-icon" viewBox="0 0 20 20" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.23 7.21a.75.75 0 0 1 1.06.02L10 11.06l3.71-3.83a.75.75 0 1 1 1.08 1.04l-4.25 4.4a.75.75 0 0 1-1.08 0l-4.25-4.4a.75.75 0 0 1 .02-1.06z"/>
              </svg>
            </div>
            <!-- <button class="btn btn-danger btn-sm ms-2 fs-8" @click="removeAccess(acceso.idPersona)">Eliminar</button> -->
            <button v-if="newGaleria.PermisoOtorgado == 'Editor'" type="button" class="btn p-2 me-1 d-flex flex-row align-items-center justify-content-center tooltip-container border-0" @click="deleteAcceso(acceso)">
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-principal">
                <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
              <!-- <span class="tooltip-text">{{ $t('eliminar') }}</span> -->
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal para agregar nuevo galeria o editar existente -->
    <div v-if="showModal && newGaleria.PermisoOtorgado == 'Editor'" class="modal-overlay">
      <div class="modal-container sombra texto-principal">
        <div class="modal-content fondo-principal text-start">
          <div class="d-flex flex-row justify-content-between align-items-top gap-2 mb-3">
            <div class="d-flex flex-row justify-content-center align-items-center gap-2">
              <h3 v-if="!newGaleria?.IdContenido && !newGaleria.EsCarpeta" class="m-0">{{ $t('nuevaGaleria') }}</h3>
              <h3 v-if="newGaleria?.IdContenido && !newGaleria.EsCarpeta" class="m-0">{{ $t('galeria') }}</h3>
              <h3 v-if="newGaleria.EsCarpeta" class="m-0">{{ $t('carpeta') }}</h3>
              <svg v-if="newGaleria.EsCarpeta" width="25" height="25" viewBox="0 0 24 24" class="stroke-principal" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M3 8.2C3 7.07989 3 6.51984 3.21799 6.09202C3.40973 5.71569 3.71569 5.40973 4.09202 5.21799C4.51984 5 5.0799 5 6.2 5H9.67452C10.1637 5 10.4083 5 10.6385 5.05526C10.8425 5.10425 11.0376 5.18506 11.2166 5.29472C11.4184 5.4184 11.5914 5.59135 11.9373 5.93726L12.0627 6.06274C12.4086 6.40865 12.5816 6.5816 12.7834 6.70528C12.9624 6.81494 13.1575 6.89575 13.3615 6.94474C13.5917 7 13.8363 7 14.3255 7H17.8C18.9201 7 19.4802 7 19.908 7.21799C20.2843 7.40973 20.5903 7.71569 20.782 8.09202C21 8.51984 21 9.0799 21 10.2V15.8C21 16.9201 21 17.4802 20.782 17.908C20.5903 18.2843 20.2843 18.5903 19.908 18.782C19.4802 19 18.9201 19 17.8 19H6.2C5.07989 19 4.51984 19 4.09202 18.782C3.71569 18.5903 3.40973 18.2843 3.21799 17.908C3 17.4802 3 16.9201 3 15.8V8.2Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
            <svg width="28" height="28" viewBox="4 4 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" @click="closeModal" style="cursor: pointer;">
              <g clip-path="url(#clip0_429_11083)">
                <path d="M7 7.00006L17 17.0001M7 17.0001L17 7.00006" class="stroke-principal" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </g>
              <defs>
                <clipPath id="clip0_429_11083">
                  <rect width="24" height="24" class="fill-principal"/>
                </clipPath>
              </defs>
            </svg>
          </div>
          <form @submit.prevent="submitForm" class="d-flex flex-column gap-2">
            <div class="d-flex flex-column flex-md-row gap-md-2">
              <div class="w-100">
                <input type="text" id="titulo" v-model="newGaleria.Titulo" :placeholder="$t('titulo')" class="form-control sombra-sm" required />
              </div>
              <!-- <input type="date" id="fechaCreacion" v-model="newGaleria.FechaCreacion" class="form-control sombra-sm" required /> -->
            </div>

            <input type="text" id="descripcion" v-model="newGaleria.Descripcion" :placeholder="$t('descripcion')" class="form-control sombra-sm"/>
            <div v-if="newGaleria.IsEditing" class="form-check form-switch">
              <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault" v-model="newGaleria.Habilitado" >
              <label class="form-check-label" style="margin-top: 2px;" for="flexSwitchCheckDefault">{{ $t('habilitado') }}</label>
            </div>
            <div class="form-check form-switch">
              <input class="form-check-input" type="checkbox" role="switch" id="flexSwitchCheckDefault2" v-model="newGaleria.EsPublicoATodos" >
              <label class="form-check-label" style="margin-top: 2px;" for="flexSwitchCheckDefault2">{{ $t('esPublicaATodos') }}</label>
            </div>
            <!-- Divider -->
            <div class="col-12 my-2 borde-linea" style="border-top: 1px solid; height: 1px"></div>
            
            <div class="d-flex flex-column">
              <label v-if="!newGaleria.LogoUrl" for="archivo" class="form-label">{{ $t('imagenPortada') }}</label>
              <!-- Imagen -->
              <div class="d-flex gap-2 w-100 align-items-center">
                <img v-if="newGaleria.ImagenUrl" :src="newGaleria.ImagenUrl" alt="Galeria" class=" rounded-3 object-fit-cover" style="height: 50px; min-width: 100px; width: 100px;">
                <input v-if="!newGaleria.LogoUrl" type="file" id="archivo" @change="handleFileUpload($event, newGaleria)" class="form-control sombra-sm"/>
              </div>
            </div>

            <div v-if="newGaleria.loadingFile" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
              <img src="../assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
            </div>

            <!-- Divider -->
            <div v-if="!newGaleria.EsCarpeta" class="col-12 my-2 borde-linea" style="border-top: 1px solid; height: 1px"></div>
            <div v-if="!newGaleria.EsCarpeta" class="d-flex align-items-center position-relative w-100 gap-2">
              <svg width="25" height="25" viewBox="0 0 192 192" xmlns="http://www.w3.org/2000/svg" style="enable-background:new 0 0 192 192; pointer-events: none" xml:space="preserve"
                class="position-absolute top-50 start-0 translate-middle-y ms-2 text-secondary stroke-terciario">
                <path d="M84 128.6H54.6C36.6 128.6 22 114 22 96c0-9 3.7-17.2 9.6-23.1 5.9-5.9 14.1-9.6 23.1-9.6H84m24 65.3h29.4c9 0 17.2-3.7 23.1-9.6 5.9-5.9 9.6-14.1 9.6-23.1 0-18-14.6-32.6-32.6-32.6H108M67.9 96h56.2" style="fill:none;stroke-width:12;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10"/>
              </svg>
              <input type="url" id="redireccion" v-model="newGaleria.RedirectionUrl" :placeholder="$t('urlRedireccion')"
                style="padding-left: 40px;" class="form-control sombra-sm"/>
            </div>

            <div class="d-flex flex-row justify-content-between align-items-bottom gap-2 mt-2">
              <div class="d-flex flex-row gap-2">
                <button type="submit" class="btn btn-success sombra-sm">{{ $t('guardar') }}</button>
                <button @click="closeModal" type="button" class="btn btn-secondary sombra-sm">{{ $t('cancelar') }}</button>
                <div v-if="loadingSave" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
                  <img src="../assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
                </div>
              </div>
              <button v-if="newGaleria.IsEditing" type="button" class="btn p-0 px-1" @click="removeGaleria(newGaleria)">
                <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="stroke-secundario">
                  <path d="M10 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M14 11V17" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M4 7H20" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6 7H12H18V18C18 19.6569 16.6569 21 15 21H9C7.34315 21 6 19.6569 6 18V7Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M9 5C9 3.89543 9.89543 3 11 3H13C14.1046 3 15 3.89543 15 5V7H9V5Z" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
              <div v-if="loadingRemove" class="loading-spinner d-flex flex-row align-items-center justify-content-center">
                <img src="../assets/LOADING.gif" style="width: 40px;" alt="Cargando..." />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>

    
    <!-- Overlay y modal flotante de compartir -->
    <div v-if="showShareMenu" class="overlay" @click="showShareMenu = null"></div>
    <div v-if="showShareMenu" class="share-menu fondo-principal">
      <div class="close-icon d-flex align-items-center" @click="showShareMenu = null">
        <svg width="25" height="25" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_429_11083)">
            <path d="M7 7.00006L17 17.0001M7 17.0001L17 7.00006" class="stroke-principal" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"/>
          </g>
          <defs>
            <clipPath id="clip0_429_11083">
              <rect width="24" height="24" class="fill-principal"/>
            </clipPath>
          </defs>
        </svg>
      </div>
      <p>{{ $t('copiarEnlaceParaCompartir') }}:</p>
      <div class="d-flex flex-row align-items-center">
        <input type="text" v-model="urlCompartir" class="form-control fondo-secundario borde-principal sombra-sm" />
        <div class="tooltip-container">
          <button class="btn pb-2" @click="copyLink()">
            <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M19.5 16.5L19.5 4.5L18.75 3.75H9L8.25 4.5L8.25 7.5L5.25 7.5L4.5 8.25V20.25L5.25 21H15L15.75 20.25V17.25H18.75L19.5 16.5ZM15.75 15.75L15.75 8.25L15 7.5L9.75 7.5V5.25L18 5.25V15.75H15.75ZM6 9L14.25 9L14.25 19.5L6 19.5L6 9Z" class="fill-principal"/>
            </svg>
          </button>
          <span class="tooltip-text">{{ $t('copiar') }}</span>
        </div>
      </div>
    </div>
    
    <div v-if="errorGaleria" class="d-flex flex-column flex-sm-row align-items-center justify-content-center gap-2">
      <div class="order-1 order-sm-2">
        <p class="m-0 fs-1 fw-bold">Oops...</p>
        <p class="m-0 fs-4">{{ $t('noEncontramosGaleria') }}</p>
      </div>
      <img src="../assets/errorGoethe.png" alt="ErrorGoethe" class="img-responsive order-2 order-sm-1" style="width: 40vw;max-width: 400px; height: auto;" />
    </div>
  </div>
</template>

<script>
  import { computed, onMounted, onUnmounted, ref } from 'vue';
  import { useStore } from "vuex";
  import { useRouter } from "vue-router";
  import api from '@/services/api';

export default {
  name: "GaleriasPage",
  setup() {
    const galerias = ref([]);
    const showModal = ref(false);
    const errorGaleria = ref(false);
    const store = useStore();
    const user = computed(() => store.state.user);
    const router = useRouter();
    const CrearGalerias = ref(false);
    const filteredPersonas = ref([]); // Personas filtradas
    const loading = ref(false);
    const loadingRemove = ref(false);
    const loadingSubmitAcceso = ref(false);
    const loadingListas = ref(false);
    const loadingSave = ref(false);
    const verGaleriasHijas = ref(false);
    const GaleriaPadre = ref(null);
    const loadingFile = ref(false);
    const showModalAcceso = ref(false);
    const personas = ref([]);
    const grupos = ref([]);
    const gruposDisponibles = ref([]);
    const tipoAcceso = ref('persona');
    const tipoPermiso = ref('Lector');
    const filteredLista = ref([]); // Personas filtradas
    const selectedPersona = ref(null); // Persona seleccionada
    const selectedLista = ref(null);
    const conEnvio = ref(true);
    const searchQuery = ref(''); // Estado para la búsqueda
    const IdGaleria = ref('');
    const searchTerm = ref('');
    const errorMessage = ref('');
    let timeoutId = null;
    const showShareMenu = ref('');
    const urlCompartir = ref('');
    const loader = ref(null);
    const newGaleria = ref({
      Titulo: "",
      Descripcion: "",
      ImagenUrl: "",
      LogoUrl: "",
      RedirectionUrl: "",
      Habilitado: true,
      FechaCreacion: null,
      loadingFile: false,
      IsEditing: false,
      ContenidoTipos: [{ IdContenido: "00000000-0000-0000-0000-000000000000", IdTipoContenido: "6f4c10d6-70dd-4f7e-b3f4-a21831b045b6" }],
      ChildContenido: []
    });
    const accesoGaleria = ref({
      IdGaleria: "",
      IdLista: "",
      IdPersona: "",
      TipoPermiso: "",
      FechaHora: null,
    })
    const logos = [{title:"Error",codigo:"<svg width='25' height='25' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><path fill-rule='evenodd' clip-rule='evenodd' d='M6.47 5.777C6.64843 5.66548 6.82631 5.57017 7.00005 5.48867C7.00341 5.24634 7.03488 5.00375 7.08016 4.76601C7.15702 4.36251 7.31232 3.81288 7.63176 3.25386C8.30808 2.0703 9.63768 1 12 1C14.3623 1 15.6919 2.0703 16.3682 3.25386C16.6877 3.81288 16.843 4.36251 16.9198 4.76601C16.9651 5.00366 16.9966 5.24615 16.9999 5.48839C17.1737 5.56989 17.3516 5.66548 17.53 5.777C18.207 6.20012 18.8425 6.82582 19.2994 7.71927C19.7656 7.53233 20.2282 7.23 20.5429 6.7578C20.7966 6.3773 21 5.82502 21 5C21 4.44772 21.4477 4 22 4C22.5523 4 23 4.44772 23 5C23 6.17498 22.7034 7.1227 22.2071 7.8672C21.5676 8.82639 20.6756 9.34444 19.8991 9.63125C19.9646 10.0513 20 10.5067 20 11V12H22C22.5523 12 23 12.4477 23 13C23 13.5523 22.5523 14 22 14H20V15.5191C19.9891 15.8049 19.9498 16.088 19.9016 16.3697C20.6774 16.6566 21.5683 17.1746 22.2071 18.1328C22.7034 18.8773 23 19.825 23 21C23 21.5523 22.5523 22 22 22C21.4477 22 21 21.5523 21 21C21 20.175 20.7966 19.6227 20.5429 19.2422C20.2401 18.7879 19.8018 18.4912 19.3524 18.3025C19.2288 18.6068 19.0814 18.9213 18.9053 19.237C17.8448 21.1392 15.7816 23 12 23C8.2184 23 6.15524 21.1392 5.09465 19.237C4.91864 18.9213 4.77118 18.6068 4.6476 18.3025C4.19823 18.4912 3.75992 18.7879 3.45705 19.2422C3.20338 19.6227 3 20.175 3 21C3 21.5523 2.55228 22 2 22C1.44772 22 1 21.5523 1 21C1 19.825 1.29662 18.8773 1.79295 18.1328C2.43173 17.1746 3.32255 16.6566 4.09839 16.3697C4.05024 16.0885 4.0127 15.8043 4 15.5191V14H2C1.44772 14 1 13.5523 1 13C1 12.4477 1.44772 12 2 12H4V11C4 10.5067 4.0354 10.0513 4.10086 9.63125C3.3244 9.34444 2.43241 8.82639 1.79295 7.8672C1.29662 7.1227 1 6.17498 1 5C1 4.44772 1.44772 4 2 4C2.55228 4 3 4.44772 3 5C3 5.82502 3.20338 6.3773 3.45705 6.7578C3.77185 7.23 4.2344 7.53233 4.70063 7.71927C5.15748 6.82582 5.79302 6.20012 6.47 5.777ZM14.6318 4.24614C14.7804 4.50632 14.8709 4.77287 14.9251 5H9.07491C9.1291 4.77287 9.21957 4.50632 9.36824 4.24614C9.69192 3.6797 10.3623 3 12 3C13.6377 3 14.3081 3.6797 14.6318 4.24614ZM8.99671 7.00035C8.48495 7.02168 7.96106 7.20358 7.53 7.473C6.84294 7.90241 6 8.81983 6 11V15.4738C6.06537 16.4404 6.37182 17.4207 6.84149 18.263C7.5032 19.4498 8.69637 20.6688 11 20.943V7L8.99671 7.00035ZM13 7V20.943C15.3036 20.6688 16.4968 19.4498 17.1585 18.263C17.6282 17.4206 17.9346 16.4404 18 15.4738V11C18 8.81983 17.1571 7.90241 16.47 7.473C16.0389 7.20358 15.515 7.02168 15.0033 7.00035L13 7Z' fill='#D43838'/></svg>"},
      {title:"Agregar",codigo:"<svg width='25' height='25' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'><g id='Edit / Add_Plus_Circle'><path id='Vector' d='M8 12H12M12 12H16M12 12V16M12 12V8M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z' stroke='#6AAF42' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'/></g></svg>"},
      {title:"Subir",codigo:"<svg width='25' height='25' class='stroke-principal' viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'><title/><path d='M3,12.3v7a2,2,0,0,0,2,2H19a2,2,0,0,0,2-2v-7' fill='none' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/><g><polyline data-name='Right' fill='none' id='Right-2' points='7.9 6.7 12 2.7 16.1 6.7' stroke-linecap='round' stroke-linejoin='round' stroke-width='2'/><line fill='none' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' x1='12' x2='12' y1='16.3' y2='4.8'/></g></svg>"},
      {title:"Reporte",codigo:"<svg fill='#32ADC1' width='25' height='25' viewBox='0 0 32 32' id='icon' xmlns='http://www.w3.org/2000/svg'><defs><style>.cls-1{fill:none;}</style></defs><title>report--alt</title><rect x='10' y='18' width='8' height='2'/><rect x='10' y='13' width='12' height='2'/><rect x='10' y='23' width='5' height='2'/><path d='M25,5H22V4a2,2,0,0,0-2-2H12a2,2,0,0,0-2,2V5H7A2,2,0,0,0,5,7V28a2,2,0,0,0,2,2H25a2,2,0,0,0,2-2V7A2,2,0,0,0,25,5ZM12,4h8V8H12ZM25,28H7V7h3v3H22V7h3Z'/><rect id='_Transparent_Rectangle_' data-name='&lt;Transparent Rectangle&gt;' class='cls-1' width='32' height='32'/></svg>"}
    ]


    const currentPage = ref(1);
    const itemsPerPage = ref(8); // Mostrar 2 formularios por página

    const totalPages =  ref(1);

    const goToGaleria = (idGaleria) => {
      router.push(`/galeria?idContenido=${idGaleria}`);
    };

    const toggleShareMenu = (id) => {
      showShareMenu.value = showShareMenu.value === id ? null : id;
      urlCompartir.value = `${window.location.href.split('#')[0]}#/galeria?idContenido=${id}`;
    };

    const copyLink = () => {
      navigator.clipboard.writeText(urlCompartir.value).then(() => {
        //alert('Enlace copiado al portapapeles');
        showShareMenu.value = null;
      });
    };

    const filterGalerias = () => {
      // Limpia el temporizador anterior si existe
      if (timeoutId) {
        clearTimeout(timeoutId);
      }

      // Establece un nuevo temporizador
      timeoutId = setTimeout(() => {
        // Llama a fetchGalerias después de 500ms (0.5 segundos) de inactividad
        fetchGalerias(1);
      }, 1000); // Puedes ajustar este valor a tu gusto (en milisegundos)
    };

    const redirectUrl = (url) => {
      if (url) {
        window.open(url, '_blank');
      } else {
        console.warn('Redirection URL is empty or null.');
      }
    };


    const checkAuth = async  () => {
      if (user.value && user.value.personasPermisos) {
        if(user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation.permiso === 'Formularios') || user.value.email.some(emails => emails.email.includes('@goethe.edu.ar'))){
          console.log("Tiene Permiso")
        }
        else{
          console.log('Usuario no tiene permiso a acceder.');
          await router.push('/');
        }
        var permisoAComprobar = 'CrearGalerias'
        if (user.value.personasPermisos.some(persPermiso => persPermiso.idPermisoNavigation?.permiso === permisoAComprobar) || 
          user.value.personasRoles.some(persRoles => persRoles.idRolNavigation?.permisos?.some(p => p.permiso === permisoAComprobar))){
            CrearGalerias.value = true
        }
      }
    };

    // Función para manejar la carga de archivos
    const handleFileUpload = async (event, galeria) => {
      const file = event.target.files[0];
      if (file) {
        try {
          galeria.loadingFile = true;
          const archivoData = new FormData();
          archivoData.append('archivo', file); // Agrega el archivo

          const response = await api.post(`api/Archivos`, archivoData, {
            params: {
              hotlink: true,
            },
            headers: {
              'Content-Type': 'multipart/form-data', // Asegúrate de enviar el tipo de contenido correcto
            },
          });
          //console.log(response.data)
          // Suponiendo que la API devuelve la URL del archivo subido
          galeria.ImagenUrl = response.data.enlace; // Asigna la URL del archivo subido al campo ImagenUrl
          galeria.loadingFile = false;
        } catch (error) {
          console.error('Error al subir archivo:', error);
          galeria.loadingFile = false;
        }
      }
    };

    const handleCardClick = (url) => {
      if (url) {
        window.open(url, '_blank');
      }
      console.log('Se hizo clic en la tarjeta, redirigiendo a:', url);
    };

    const openModalNew = ( esCarpeta ) => {
      newGaleria.value = {
        Titulo: "",
        Descripcion: "",
        ImagenUrl: "",
        LogoUrl: "",
        RedirectionUrl: "",
        Habilitado: true,
        FechaCreacion: null,
        loadingFile: false,
        IsEditing: false,
        EsCarpeta: esCarpeta,
        PermisoOtorgado: 'Editor',
        EsPublicoATodos: true,
        IdCreador: user?.value.idPersona,
        ContenidoTipos: [{ IdContenido: "00000000-0000-0000-0000-000000000000", IdTipoContenido: "6f4c10d6-70dd-4f7e-b3f4-a21831b045b6" }],
        ChildContenido: []
      };
      showModal.value = true;
    };

    const openModalEdit = (galeria) => {
      newGaleria.value = { ...galeria }; // It's good practice to spread to avoid direct mutation if 'galeria' is a prop or reactivity issue

      newGaleria.value.IsEditing = true;

      // 1. Create the Date object from the string
      const dateObject = new Date(newGaleria.value.FechaCreacion);

      // 2. Format the Date object into 'YYYY-MM-DD' string
      //    Use padStart to ensure two digits for month and day
      const year = dateObject.getFullYear();
      const month = String(dateObject.getMonth() + 1).padStart(2, '0'); // Month is 0-indexed, so add 1
      const day = String(dateObject.getDate()).padStart(2, '0');

      newGaleria.value.FechaCreacion = `${year}-${month}-${day}`;

      //console.log(newGaleria.value);
      showModal.value = true;
    };

    const closeModal = () => {
      showModal.value = false;
    };

    const fetchGalerias = async (page) => {
      try {
        loading.value = true;
        if (timeoutId) {
          clearTimeout(timeoutId);
        }
        const idContenido = localStorage.getItem('idContenido');
        if(idContenido){
          IdGaleria.value = idContenido;
        }
        localStorage.removeItem('idContenido');
        let response = null;
        if(IdGaleria.value){
          response = await api.get(`api/Contenido/ById`, {
            params: {
              id: IdGaleria.value,
              tipo: 'Galería',
              searchTerm: searchTerm.value,
              order: "fechacreacion_desc",
              page: page,
              pageSize: 12,
            },
            headers: { 
              'Content-Type': 'application/json'
            },
          });

          GaleriaPadre.value = response.data.ContenidoPadre;
          //Si es la misma carpeta, agregar los nuevos hijos
          if(GaleriaPadre.value?.IdContenido == response.data.ContenidoPadre?.IdContenido && galerias.value && response.data.CurrentPage>1){
            galerias.value.push(...response.data.Items)
          }else{
            galerias.value = response.data.Items;
          }
          currentPage.value = response.data.CurrentPage;
          totalPages.value = response.data.TotalPages;

          
          //console.log(GaleriaPadre.value)
          //console.log(galerias.value)
        }else{
          response = await api.get(`api/Contenido/ByTipo`, {
            params: {
              tipo: 'Galería',
              searchTerm: searchTerm.value,
              order: "fechacreacion_desc",
              page: page,
              pageSize: 12,
            },
            headers: { 
              'Content-Type': 'application/json'
            },
          });
          GaleriaPadre.value = null;
          if(galerias.value && response.data.CurrentPage>1){
            galerias.value.push(...response.data.Items)
          }else{
            galerias.value = response.data.Items;
          }
          currentPage.value = response.data.CurrentPage;
          totalPages.value = response.data.TotalPages;
        }
        console.log(galerias.value)
        loading.value = false;
        if(galerias.value.length == 0){
          errorGaleria.value = true
        }else {
          errorGaleria.value = false
        }

        //Actualiza el galeria que se este editando.
        if(galerias.value.some( i => i.IdContenido == newGaleria.value?.IdContenido)){
          newGaleria.value = galerias.value.find( i => i.IdContenido == newGaleria.value?.IdContenido)
        }
        else if(GaleriaPadre.value?.IdContenido == newGaleria.value?.IdContenido){
          newGaleria.value = GaleriaPadre.value
        }
        else{
          newGaleria.value = null
          showModalAcceso.value = false
        }
      } catch (error) {
        console.error('Error al obtener las galerias:', error);
        loading.value = false;
        errorGaleria.value = true
      }
    };

    // Creamos una única instancia del observer
    const observer = new IntersectionObserver(([entry]) => {
      // Si el elemento 'loader' es visible en la pantalla (isIntersecting)
      // y no estamos ya cargando, y no hemos llegado al final...
      if (entry && entry.isIntersecting && !loading.value && currentPage.value < totalPages.value) {
        // ...cargamos la siguiente página.
        fetchGalerias(currentPage.value + 1);
      }
    });

    const submitForm = async () => {
      try {
        loadingSave.value = true;
        newGaleria.value.ContenidoTipos = [
          {
            "IdContenido": "00000000-0000-0000-0000-000000000000",
            "IdTipoContenido": "6f4c10d6-70dd-4f7e-b3f4-a21831b045b6"
          }
        ];
        delete newGaleria.value.loadingFile;
        newGaleria.value.ChildContenido = null;
        //Si tiene un padre que no es si mismo, lo agrega al objeto
        if(GaleriaPadre.value && GaleriaPadre.value?.IdContenido != newGaleria.value?.IdContenido){
          newGaleria.value.IdContenidoPadre = GaleriaPadre.value?.IdContenido;
        }
        //console.log(newGaleria.value)
        //Si se esta editando
        if(newGaleria.value.IsEditing == true){
          newGaleria.value.FechaModificacion = new Date()
          await api.put(`api/Contenido/`+newGaleria.value.IdContenido, newGaleria.value);
          delete newGaleria.value.IsEditing;
        }else{
          //Si se esta creando uno nuevo
          newGaleria.value.FechaCreacion = new Date()
          await api.post(`api/Contenido`, newGaleria.value);
          delete newGaleria.value.IsEditing;
        }
        console.log('Galería agregada');
        fetchGalerias(1); // Actualizar la lista de galerias
        closeModal(); // Cerrar el modal
        loadingSave.value = false;
      } catch (error) {
        loadingSave.value = false;
        console.error('Error al agregar la galeria:', error);
      }
    };


    const removeGaleria = async (galeria) => {
      if(galeria){
        if (confirm("¿Estás seguro de que deseas borrar la Galeria?")) {
          try {
            loadingRemove.value = true;
            await api.delete(`api/Contenido/` + galeria?.IdContenido);
            
            console.log('Galería eliminada');
            fetchGalerias(1); // Actualizar la lista de galerias
            closeModal(); // Cerrar el modal
            loadingRemove.value = false;
          } catch (error) {
            loadingRemove.value = false;
            console.error('Error al agregar el galeria:', error);
          }
        }
      }
    };

    // Obtener las personas para dar acceso
    const fetchPersonas = async () => {
      try {
        const response = await api.get(`api/Persona/ByRole?role=Empleado`);
        const idPersonaExcluida = user.value?.idPersona; // Reemplaza con el ID de la persona a excluir
        personas.value = response.data.filter(persona => persona.IdPersona !== idPersonaExcluida);
      } catch (error) {
        console.error('Error al obtener los tipos de observación:', error);
      }
    };
        // Filtrar personas basadas en el input de búsqueda
    const filterPersonas = () => {
      if (searchQuery.value == '') {
        filteredPersonas.value = [];
      } else {
        const query = searchQuery.value.toLowerCase();
        filteredPersonas.value = personas.value.filter(evaluado => {
          const nombreCompleto = `${evaluado.Apellido} ${evaluado.Nombre}`.toLowerCase();
          const correo = evaluado.Email && evaluado.Email.length > 0 ? evaluado.Email[0].email.toLowerCase() : '';

          return nombreCompleto.includes(query.toLowerCase()) || correo.includes(query.toLowerCase());
        }).slice(0, 10);
      }
    };
    const selectPersona = (evaluado) => {
      selectedPersona.value = evaluado.IdPersona; // Asigna la persona seleccionada
      //fetchAsignaturas();
      searchQuery.value = `${evaluado.Apellido} ${evaluado.Nombre}`; // Muestra el nombre en el input
      filteredPersonas.value = []; // Limpia la lista filtrada
    };
    

    const fetchGrupos = async () => {
      try {
        loadingListas.value = true;
        const response = await api.get(`api/Grupos`);
        
        response.data.forEach(grupo =>{
          grupo.Listas.forEach(opcion =>{
            gruposDisponibles.value.push({
              IdLista: opcion.IdLista,
              Nombre: grupo.Nombre + ' -> ' + opcion.Nombre
            })
          })
        })
        //console.log(gruposDisponibles.value)
        loadingListas.value = false;
      } catch (error) {
        loadingListas.value = false;
        console.error('Error al obtener los tipos de observación:', error);
      }
    };
    const filterLista = () => {
      if (searchQuery.value === '') {
        filteredLista.value = [];
        return; // Salir si la búsqueda está vacía
      }

      const query = searchQuery.value;
      const lowerCaseQuery = query.toLowerCase();
      
      // Dividir la consulta en palabras individuales
      const queryWords = lowerCaseQuery.split(' ').filter(word => word.length > 0);

      // Paso 1: Filtrar y priorizar coincidencias exactas (case-sensitive)
      const exactMatches = gruposDisponibles.value.filter(lista => {
        return lista.Nombre.includes(query);
      });

      // Paso 2: Filtrar coincidencias (case-insensitive) y por palabras individuales
      const otherMatches = gruposDisponibles.value.filter(lista => {
        const nombreLowerCase = lista.Nombre.toLowerCase();
        
        // Evitar duplicados con las coincidencias exactas
        if (exactMatches.includes(lista)) {
          return false;
        }

        // Buscar si el nombre incluye la consulta completa (case-insensitive)
        if (nombreLowerCase.includes(lowerCaseQuery)) {
          return true;
        }

        // Buscar si el nombre incluye TODAS las palabras individuales de la consulta
        return queryWords.every(word => nombreLowerCase.includes(word));
      });

      // Paso 3: Combinar y ordenar los resultados
      const combinedResults = [...exactMatches, ...otherMatches];

      // Si quieres limitar el número de resultados, aplica slice aquí
      //filteredLista.value = combinedResults.slice(0, 10);
      filteredLista.value = combinedResults;
    };
    const selectLista = (lista) => {
      selectedLista.value = lista.IdLista; // Asigna la persona seleccionada
      //fetchAsignaturas();
      searchQuery.value = `${lista.Nombre}`; // Muestra el nombre en el input
      filteredLista.value = []; // Limpia la lista filtrada
    };

        //Le da ACCESO al formulario a X persona
    const submit = async () => {
      try {
        loadingSubmitAcceso.value = true;  // Mostrar el cargador
        accesoGaleria.value.IdContenido = newGaleria.value?.IdContenido
        accesoGaleria.value.IdLista = selectedLista.value
        accesoGaleria.value.IdPersona = selectedPersona.value
        accesoGaleria.value.TipoPermiso = tipoPermiso.value
        
        const response = await api.post(`api/AccesoContenido`, JSON.stringify(accesoGaleria.value), {
          params: {
            conEnvio: conEnvio.value,
          },
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (response.status === 500) {
          throw new Error('Error interno en el Servidor.');
        }
        selectedLista.value = null;
        selectedPersona.value = null;
        fetchGalerias(currentPage.value);
        searchQuery.value = '';
      } catch (error) {
        loadingSubmitAcceso.value = false; // Detener el cargador
        if (error.response && error.response.status === 409) {
          errorMessage.value = error.response.data;
        } else {
          errorMessage.value = "Ocurrió un error inesperado. Por favor, intente de nuevo más tarde.";
        }
      } finally {
        loadingSubmitAcceso.value = false;  // Detener el cargador
      }
    };

    const actualizarAcceso = async (acceso) => {
      try {
        const response = await api.put(`api/AccesoContenido`, JSON.stringify(acceso), {
          headers: {
            'Content-Type': 'application/json',
          },
        });

        if (response.status === 500) {
          throw new Error('Error interno en el Servidor.');
        }
        fetchGalerias(currentPage.value);
      } catch (error) {
        loadingSubmitAcceso.value = false; // Detener el cargador
        if (error.response && error.response.status === 409) {
          alert(error.response.data)
        } else {
          alert("Ocurrió un error inesperado. Por favor, intente de nuevo más tarde.")
        }
      }
    };

    const deleteAcceso = async (acceso) => {
      try {
        await api.delete(`api/AccesoContenido/`+ acceso.IdAccesoContenido);
        fetchGalerias(currentPage.value);
      } catch (error) {
        console.error('Error al obtener formularios:', error);
      }
    };

    onMounted(() => {
      const lastUpdate = localStorage.getItem("lastUpdate");
      const today = new Date().toISOString().split("T")[0]; // Obtiene solo la fecha (YYYY-MM-DD)

      if (loader.value) {
        observer.observe(loader.value);
      }
      if (lastUpdate !== today) {
        localStorage.setItem("lastUpdate", today);
        window.location.reload(); // Recarga la página solo si no se ha recargado hoy
      }
      checkAuth();
      fetchGalerias(1);
      fetchPersonas();
      fetchGrupos();
    });

    // Cuando el componente se destruye, dejamos de observar para evitar memory leaks.
    onUnmounted(() => {
      if (loader.value) {
        observer.unobserve(loader.value);
      }
    });

    return {
      galerias,
      showModal,
      newGaleria,
      openModalNew,
      openModalEdit,
      closeModal,
      submitForm,
      CrearGalerias,
      loading,
      loadingSave,
      handleFileUpload,
      loadingFile,
      verGaleriasHijas,
      GaleriaPadre,
      handleCardClick,
      searchTerm,
      currentPage,
      itemsPerPage,
      totalPages,
      redirectUrl,
      removeGaleria,
      loadingRemove,
      logos,
      goToGaleria,
      filterGalerias,
      fetchGalerias,
      loader,
      errorGaleria,
      tipoAcceso,
      filteredPersonas,
      errorMessage,
      deleteAcceso,
      actualizarAcceso,
      submit,
      searchQuery,
      personas,
      grupos,
      gruposDisponibles,
      filterPersonas,
      selectPersona,
      filterLista,
      selectLista,
      conEnvio,
      showModalAcceso,
      loadingSubmitAcceso,
      tipoPermiso,
      filteredLista,
      copyLink,
      showShareMenu,
      toggleShareMenu,
      urlCompartir
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 10000;
}

.modal-container {
  border-radius: 8px;
  width: 1000px;
  max-width: 80%;
  padding: 0px;
  overflow: hidden;
  z-index: 2000;
}

.modal-content {
  width: 100%;
  padding: 20px;
  max-height: 90vh; /* Define la altura máxima antes de que el scroll aparezca */
  overflow-y: auto; /* Agrega scroll vertical si el contenido excede el max-height */
  z-index: 2000;
}

.card-body h3 {
  font-size: 50px;
}
</style>
